import Cookies from 'js-cookie';

import FallBack from '@/components/SuspenseFallBack';
import { KEY_MYGPT_REFRESH_TOKEN, KEY_MYGPT_TOKEN, KEY_MYGPT_TOKEN_EXPIRESIN } from '@mygpt/app';
import { useLogin } from '@/hooks/useLogin';

export function RequireAuth({ children }: { children: JSX.Element }) {
  const { login, refreshToken: refreshTokenMethod, savePath } = useLogin();

  const token = Cookies.get(KEY_MYGPT_TOKEN());
  const tokenExpires = Cookies.get(KEY_MYGPT_TOKEN_EXPIRESIN());
  const refreshToken = Cookies.get(KEY_MYGPT_REFRESH_TOKEN());

  // 检查是否有token
  // 检查是否过期
  // 是否替换token成功
  // 否则跳去登录
  let needLogin = false;

  // 原有鉴权流程：无 token / token 过期且无法刷新时才触发登录跳转
  for (;;) {
    if (!token) {
      needLogin = true;
      break;
    }

    if (tokenExpires) {
      const nowTime = new Date().getTime();
      const expiresTime = Number(tokenExpires);
      if (expiresTime > nowTime) break;
    }

    if (refreshToken) {
      const data = refreshTokenMethod();
      if (!data) {
        needLogin = true;
        break;
      }
    }

    break;
  }

  if (needLogin) {
    // 保存当前路径，注册后跳转回来使用
    savePath(window.location.href);
    login(window.location.href);
    return <FallBack />;
  } else {
    return children;
  }
}
